import React, {Component} from 'react';
import AuthenticationService from "../../Services/AuthenticationService";
import {
    Button,
    ButtonGroup,
    ClickAwayListener,
    Grow,
    MenuItem,
    MenuList,
    Paper,
    Popper,
    TextField,
} from "@material-ui/core";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Grid from "@material-ui/core/Grid";
import ManageTINsforNNUSTable from './ManageTINsforNNUSTable';
import { isNotEmpty} from '../../utils/Validator.js';
import './ManageTinsForNNUS.css'
import LoadingMsgBar from "../LoadingMsgBar.js";
import GlobalMessage from "../GlobalMessage.js";

window.analytics ={pageName:'Manage Users: Manage TINs'};
class ManageTINsforNNUS extends Component {
    constructor(props) {
        super(props);
        this.state = {
            response: [], nnusTin:'', nnusTins:[], filterednnusTins: [], selected: [], errorMsg: '',nnusTinError:'',isAddButtonEnabled: false, loadingMessage: '', loggedInUserName: '',
                      successMsg:'', splitOpen: false,
        }
        this.splitAnchorRef = React.createRef();
    }
    componentDidMount() {
        this.loadList(); 
        let userISAD = AuthenticationService.getLoggedInUserName();
        this.setState({loggedInUserName:userISAD});
    }

    setErrorMsg = () => {
        this.setState({progMsg:'', errorMsg: `Error:  An error has occurred.  Please try again or contact Customer Service.`})
    }

   

    loadList = () => {
         this.setState({
                nnusTins: [],
                filterednnusTins:[],
                nnusTin: '',  // Clear input after adding
                nnusTinError: '',
                isAddButtonEnabled: false, 
            });
            AuthenticationService.getFtinsForUser(this.props.location.state.user.grpInfoId)
                .then((response) => {
                    const tins= []
    
                    response.data.forEach(tin =>{
                        const addedDate = new Date(tin.addedDate + "T00:00:00Z" ) 
                        tin.displayDate =  `${addedDate.getUTCMonth()+1}/${addedDate.getUTCDate()}/${addedDate.getUTCFullYear()}`
                        tins.push(tin)
                    })
                    this.setState({nnusTins: tins, filterednnusTins: tins});
    
                }).catch(error => {
                this.setErrorMsg()
                console.log('Error receiving user ftins:' + error);
            })
        }

    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checkecd : target.value;
        const name = target.name;

        if (name === 'nnusTin') {
            const isButtonEnabled = value.trim() !== '';
            this.setState({
                [name]: value,
                isAddButtonEnabled: isButtonEnabled,
                nnusTinError: '' // Clear error when input changes
            });
        } else {
            this.setState({
                [name]: value
            });
        }
    }

    handleCancel = () => {  
        this.props.history.push({
            pathname: '/wcpp/UserSearch',
            state: {searchInfo: this.props.location.state.searchInfo}
        })

    }

    handleReset = () => {  
       this.setState({nnusTin:'',nnusTinError:'', isAddButtonEnabled: false, successMsg: '', errorMsg: ''});

    }

    setFilternnusTins = (filtered) => {
        console.log( `in fitler set state`)
        if(filtered && filtered.length >= 0){
            this.setState({filterednnusTins:filtered});
        }
        else{
            this.setState({filterednnusTins: []});
        }

    }

     handleRemoveNNUSTaxId = (tinObject) => {
        this.setState({nnusTinError:'', successMsg: '', errorMsg: ''});
        console.log(`Removing TIN: ${tinObject.ftin}`);
                    AuthenticationService.deleteFtin(this.props.location.state.user.grpInfoId, tinObject.ftin, this.state.loggedInUserName)
                        .then(response => {
                            if(response.status === 200  ) {
                                 this.setState({
                                        successMsg:`The selected TIN ${tinObject.ftin} has been successfully removed.`, errorMsg: ''})
                                    this.loadList();
                                   
                                
                            }
                        }).catch((error) => {
                        this.setErrorMsg()
                        console.log(`Delete TaxID error ${error}`);
                    })
     
    }

    validateBeforeAdd = () => {
        this.setState({nnusTinError:'', successMsg: '', errorMsg: ''});
        const { nnusTin, nnusTins } = this.state;
        if (!this.syntaxValidateTaxId(nnusTin)) return false;
        if (nnusTins.some(item => item.ftin === nnusTin)) {
            this.setState({ nnusTinError: 'TIN already associated to the Non-Network User' });
            return false;
        }
        return true;
    }

    handleAddNNUSTin = () => {
        if (this.validateBeforeAdd()) {
            this.validateNonNetworkFTIN();
        }
    }

    handleForceAdd = () => {
        this.setState({ splitOpen: false });
        if (this.validateBeforeAdd()) {
            // Skip backend validation — add immediately after frontend checks pass.
            this.addNonNetworkFTINSAfterValidation(true);
        }
    }

    handleSplitToggle = () => this.setState(prev => ({ splitOpen: !prev.splitOpen }));

    handleSplitClose = (event) => {
        if (this.splitAnchorRef.current && this.splitAnchorRef.current.contains(event.target)) return;
        this.setState({ splitOpen: false });
    }
    
    syntaxValidateTaxId = (nnusTin) => {
            if (nnusTin.length === 0) {
                this.setState({nnusTinError: 'Error: Enter a Tax ID Number (TIN)'})
                return false
            }
            //const exp = new RegExp("^(?=.*[0-9])")
            const exp = new RegExp('^[0-9]+$');             
            if ( exp.test(nnusTin) !== true) {
                this.setState({nnusTinError: `Error: Enter a valid Tax ID Number (TIN)`})
                return false
            }
    
            if (nnusTin.length <9) {
                this.setState({nnusTinError: 'Error: Enter a 9-digit Tax ID Number (TIN)'})
                return false
            }
    
            return true
        }

        
    showProcessingIndicator(shouldShow, message) {
            this.setState({ loadingMessage: shouldShow === true ? message :'' });
    }

    handleNonNetworkFTINError = (errorData) => {
        if (!errorData || !errorData.message) {
            this.setState({ nnusTinError: `Error: Unable to validate TIN. Please try again.` });
            return;
        }

        const errorMessages = {
            'INVALID_FTIN_IN_NETWORK': 'Error: This TIN cannot be added because it is registered as In-network TIN.  Only non-network TINs are permitted for non-network user.',
            'INVALID_FTIN_NO_BILLS_FOUND': 'Error: This TIN cannot be added because no bills exist in the system. Only TINs with existing bills can be associated with user account.',
            'FTIN_RESTRICTED_FOR_REGISTRATION': 'Error: Adding a TIN owned by our organization is not allowed.  Select a different TIN and resubmit.'
        };

        const errorMessage = errorMessages[errorData.message] || 'Error: Unable to validate TIN. Please try again.';
        this.setState({ nnusTinError: errorMessage });
    }

    validateNonNetworkFTIN = () => {
             this.setState({nnusTinError:'', successMsg: '', errorMsg: ''});
            const { nnusTin } = this.state;
            this.showProcessingIndicator(true, 'Please wait while we validate the TIN.');
            
                console.log( `Validate Non Network ftin................`)
                
                AuthenticationService.validateNonNetworkFTIN( nnusTin)
                    .then(response => {
                        this.showProcessingIndicator(false,'');
                        
                        // Handle successful 200 response
                        if(response.status === 200) {
                            this.addNonNetworkFTINSAfterValidation(nnusTin);
                        } 
                        // Handle error responses that come through as resolved promises (due to axios interceptor)
                        else if(response.response && response.response.status === 400) {
                            this.handleNonNetworkFTINError(response.response.data);
                        } 
                        // Handle any other non-200 status
                        else {
                            this.handleNonNetworkFTINError(null);
                        }
    
                 }).catch((error) => {
                    this.showProcessingIndicator(false,'');
                    // Handle actual promise rejections (network errors, etc.)
                    this.handleNonNetworkFTINError(error.response?.data);
                    console.log(`Validate non network TIN ${error.message || error}`);
             })
    }

    
    addNonNetworkFTINSAfterValidation = (forceAdd = false) => {
            this.setState({nnusTinError:'', successMsg: '', errorMsg: ''});     
             this.showProcessingIndicator(true, 'Please wait while we add the TIN.');
                
             const { nnusTin } = this.state;
             const serviceCall = forceAdd
                 ? AuthenticationService.postFtinForForceAddNNUS(this.props.location.state.user.grpInfoId, nnusTin, this.state.loggedInUserName)
                 : AuthenticationService.postFtinForNNUS(this.props.location.state.user.grpInfoId, nnusTin, this.state.loggedInUserName);
                        serviceCall
                            .then((response) => {
                                if (response.status === 200) {
                
                                     this.setState({successMsg: `TIN ${nnusTin} has been successfully added to the user.`})
                                     this.loadList();
                                    this.showProcessingIndicator(false,'');
                                    console.log(`Post ftin for NNUS DONE`);
                                    
                                } else {
                                    this.showProcessingIndicator(false, '');
                                    this.setState({errorMsg: `Error: An error has occurred.  Please try again or contact Customer Service.`});
                                }
                            }).catch((error) => {
                                this.showProcessingIndicator(false, '');
                                this.setState({errorMsg: `Error: An error has occurred.  Please try again or contact Customer Service.`});
                                console.log('Post ftin for Manage Users Error:' + error);
                            });
            
           
     }
    
       /*  addToFilterednnusTINs = (tin) => {
            this.setState(prevState => ({
                filterednnusTins: [...prevState.filterednnusTins, tin]
              }))
                    
        }  */
    
    render() {

        return(
                <div className='App-content ManageTinsForUser'>
                    <h1 className='App-page-label'>
                        {`User Search: Manage TINs for ${this.props.location.state.user.userFirstName} ${this.props.location.state.user.userLastName}`}</h1>
                    <LoadingMsgBar loadMsg={this.state.loadingMessage}/>
                    <GlobalMessage  message={this.state.errorMsg} />
                    <GlobalMessage type ='success' message={this.state.successMsg} />
                   <Grid item style={{width:'50%', textAlign:'left'}}>
                        <Grid container spacing={1} alignItems="center" wrap="nowrap">
                            <Grid item xs>
                                <TextField id="nnusTin" name="nnusTin" label="Tax Id Number(TIN)"
                                value={this.state.nnusTin}
                                error={isNotEmpty(this.state.nnusTinError)} helperText={this.state.nnusTinError} 
                                onChange={this.handleInputChange}
                                inputProps={{ maxLength: 9 }}
                                fullWidth
                                required
                                />   
                            </Grid>                       
                        </Grid>
                        <Grid item style={{ textAlign:'left'}}>
                            <Grid item>
                                {this.props.isAdmin ? (
                                    <>
                                        <ButtonGroup variant="outlined" color="primary" ref={this.splitAnchorRef}
                                            disabled={!this.state.isAddButtonEnabled} style={{ margin: '0.5rem' }}>
                                            <Button onClick={this.handleAddNNUSTin} style={{ margin: 0 }}>Add</Button>
                                            <Button size="small" aria-label="select add option" aria-haspopup="menu"
                                                onClick={this.handleSplitToggle} style={{ margin: 0 }}>
                                                <ArrowDropDownIcon />
                                            </Button>
                                        </ButtonGroup>
                                        <Popper open={this.state.splitOpen} anchorEl={this.splitAnchorRef.current}
                                            role={undefined} transition disablePortal style={{ zIndex: 1 }}>
                                            {({ TransitionProps, placement }) => (
                                                <Grow {...TransitionProps}
                                                    style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}>
                                                    <Paper>
                                                        <ClickAwayListener onClickAway={this.handleSplitClose}>
                                                            <MenuList>
                                                                <MenuItem onClick={this.handleForceAdd}>Force-Add</MenuItem>
                                                            </MenuList>
                                                        </ClickAwayListener>
                                                    </Paper>
                                                </Grow>
                                            )}
                                        </Popper>
                                    </>
                                ) : (
                                    <Button variant="outlined" disabled={!this.state.isAddButtonEnabled}
                                        onClick={this.handleAddNNUSTin}>Add</Button>
                                )}
                                <Button 
                                variant="outlined" 
                                    onClick={this.handleReset}
                                    disabled={!this.state.isAddButtonEnabled}
                                    > Reset
                                </Button>
                                <Button 
                                variant="outlined" 
                                    onClick={this.handleCancel}
                                    > Cancel
                                </Button>
                            </Grid>
                        </Grid>                  
                                             
                        <ManageTINsforNNUSTable 
                            rows={this.state.nnusTins} 
                            filtered={this.state.filterednnusTins} 
                            setFilter={this.setFilternnusTins}  
                            deleteRow={this.handleRemoveNNUSTaxId} 
                        /> 
                    </Grid>                                           

                </div>
           
        );

    }
}
export default ManageTINsforNNUS;